import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import CreateZone from './CreateZone';
import CopyZone from './CopyZone';

class ZoneHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addModalOpened: false,
      copyModalOpened: false,
    };

    this._showCreate = this._showCreate.bind(this);
    this._hideCreate = this._hideCreate.bind(this);
    this._showCopy = this._showCopy.bind(this);
    this._hideCopy = this._hideCopy.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && !nextProps.isCreating) {
      // Creation done, hiding modal
      this.setState({
        addModalOpened: false,
      });
    }
    if (this.props.isCopying && !nextProps.isCopying) {
      // Copy done, hiding modal
      this.setState({
        copyModalOpened: false,
      });
    }
  }

  _showCreate(evt) {
    evt.preventDefault();

    this.setState({
      addModalOpened: true,
    });
  }

  _hideCreate() {
    this.setState({
      addModalOpened: false,
    });
  }

  _showCopy(evt) {
    evt.preventDefault();

    this.setState({
      copyModalOpened: true,
    });
  }

  _hideCopy() {
    this.setState({
      copyModalOpened: false,
    });
  }

  render() {
    const { addModalOpened, copyModalOpened } = this.state;
    const {
      onCreate,
      canAdd,
      onCopy,
      zonesRef,
      zoneTemplatesRef,
      hasCreateZoneError,
      taskType,
    } = this.props;

    return (
      <h4 className="ui dividing header">
        Plan d'appâtage
        {canAdd && (
          <button
            className="ui right floated labeled icon button"
            onClick={this._showCopy}
          >
            <i className="icon undo" />
            Récupérer un lieu
          </button>
        )}
        {canAdd && (
          <button
            className="ui right floated labeled icon button"
            onClick={this._showCreate}
          >
            <i className="icon add" />
            Créer un lieu
          </button>
        )}
        {addModalOpened && (
          <CreateZone
            onSubmit={onCreate}
            onClose={this._hideCreate}
            taskType={taskType}
            hasError={hasCreateZoneError}
          />
        )}
        {copyModalOpened && (
          <CopyZone
            onSubmit={onCopy}
            onClose={this._hideCopy}
            zonesRef={zonesRef}
            zoneTemplatesRef={zoneTemplatesRef}
          />
        )}
      </h4>
    );
  }
}

ZoneHeader.propTypes = {
  isCreating: PropTypes.bool.isRequired,
  onCreate: PropTypes.func.isRequired,
  isCopying: PropTypes.bool.isRequired,
  onCopy: PropTypes.func.isRequired,
  canAdd: PropTypes.bool,
  zonesRef: PropTypes.array.isRequired,
  zoneTemplatesRef: PropTypes.array.isRequired,
  hasCreateZoneError: PropTypes.bool.isRequired,
};

export default ZoneHeader;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/ZoneHeader.js